import OfficerList from "../container/Officer/OfficerList";
import CreateOfficer from "../container/Officer/CreateOfficer";
import UpdateOfficer from "../container/Officer/UpdateOfficer";
import {Route, Routes} from "react-router-dom";

const Officer = () => {
  return (
    <Routes>
      <Route path="/*" element={<OfficerList />} />
      <Route path="Create" element={<CreateOfficer />} />
      <Route path="Edit/:id" element={<UpdateOfficer />} />
    </Routes>
  );
};

export default Officer;
